import { useSyncExternalStore } from 'react';

// While an iframe in the window holds the focus, the blur of the app goes to the iframe's
// window and this one hears nothing. A slow look catches that case
const RECHECK_MS = 5_000;

const subscribe = (onChange: () => void) => {
  window.addEventListener('focus', onChange);
  window.addEventListener('blur', onChange);
  const recheck = setInterval(onChange, RECHECK_MS);
  return () => {
    window.removeEventListener('focus', onChange);
    window.removeEventListener('blur', onChange);
    clearInterval(recheck);
  };
};

const getSnapshot = () => document.hasFocus();

// True while the user has this window in front. A window that stays visible beside the
// app the user works in is not focused
export const useWindowFocused = () =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
